import React from 'react'
import { Box, Container } from '@mui/material'
import { useTranslation } from 'react-i18next'

import Header from '@core/components/header'

const errorMessageKeys = {
  USER_NOT_FOUND_DB: 'user_not_found_db',
  USER_WITHOUT_CUSTOMER: 'user_without_customer',
  USER_NOT_FOUND_AUTH0: 'user_not_found_auth0',
  FATAL_ERROR: 'fatal_error',
} as const

export type ErrorCode = keyof typeof errorMessageKeys

const UserError = (props: { code: ErrorCode | string; email?: string }) => {
  const { t } = useTranslation('legacy', { keyPrefix: 'errors' })

  const messageKey = errorMessageKeys[props.code as keyof typeof errorMessageKeys]
  const message = messageKey ? <span>{t(messageKey)}</span> : <span>{props.code}</span>

  return (
    <>
      <Header />
      <Container sx={{ py: 2 }}>
        <Box mt={5}>
          <Box typography="body2" color="primary.light">
            <i>{props.email}</i>
          </Box>
          <Box typography="h2" my={2}>
            {t('unable_to_connect')}
          </Box>
          <Box typography="body1" sx={{ maxWidth: { xs: '100%', sm: '60%' } }}>
            {message}
          </Box>

          <Box typography="caption" my={5}>
            <b>{props.code}</b>
          </Box>
        </Box>
      </Container>
    </>
  )
}

export default UserError
